import { VBTooltip } from "bootstrap-vue";
import Checkbox from "./checkbox.vue";

export default {
  directives: {
    "b-tooltip": VBTooltip
  },

  components: {
    Checkbox
  },

  props: {
    submitUrl: {
      type: String,
      required: true
    },
    address: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      form: {},
      errors: []
    };
  },

  methods: {
    handleSubmit() {
      this.errors = [];
      const data = { ...this.form, ...this.address };
      const request = {};

      Object.keys(data).forEach(key => {
        request[key.replace(/_/g, "-")] = data[key];
      });

      request["lead-source"] = window.App.source;

      $.post(this.submitUrl, request).done(res => {
        if (res.status === "mail_sent") {
          if (window.fbq) {
            window.fbq("track", "Lead");
          }

          // eslint-disable-next-line
          if (window._tfa) {
            // eslint-disable-next-line
            window._tfa.push({ notify: 'event', name: 'lead', id: 1210470 });
          }

          if (
            !(
              this.form.employment === "Unemployed" &&
              this.form.court_judgement === "Yes"
            )
          ) {
            window.location.href = window.App.qualifiedPage;
          } else {
            window.location.href = window.App.nonQualifiedPage;
          }

          return;
        }

        const errors = res.invalidFields.map(item => item.message);
        this.errors = [res.message, ...errors];
      });
    }
  }
};
